<template>
  <div class="faq">
    <section>
      <h1 v-if="faq">{{ $t("faq.title") }}</h1>
      <h1 v-if="!faq">{{ $t("rec.title") }}</h1>
    </section>
    <section class="accordion-test">
      <article v-if="faq" class="accordion-faq">
        <FaqItem
          v-for = "(item, index) in $t('faq.items')"
          :key = index
          :index = index
          :itemHide = item.hide
          origin = "faq"
          :question = item.question
          :response = [item.response]
          @show-faq = "showFaq"
        />
      </article>
      <article v-if="!faq" class="accordion-faq">
        <FaqItem
            v-for = "(item, index) in $t('rec.items')"
            :key = index
            :index = index
            :itemHide = item.hide
            origin = "rec"
            :question = item.titre
            :response = item.responses
            @show-faq = "showFaq"
        />
      </article>
      <br><br><br><br>
    </section>
  </div>
</template>

<script>
import FaqItem from "@/components/old/faqItem";
export default {
  name: "Faq",

  components: {
    FaqItem
  },

  props: {
    faq: {
      type: Boolean,
      required: true,
    },
  },

  updated() {
    if (this.recharge) {
      for (let i = 0; i < this.FAQ.length; i++) {
        this.FAQ[i].hide = true
      }
      for (let i = 0; i < this.recommendations.length; i++) {
        this.recommendations[i].hide = true
      }
      this.recharge = false
    }
  },

  beforeRouteLeave(to, from, next) {
    this.recharge = true
    next()
  },

  data: function() {
    return {
      recharge: false,
      FAQ: this.$t("faq.items"),
      recommendations: this.$t("rec.items"),
    }
  },

  methods: {
    showFaq(origin, index) {
      switch (origin) {
        case 'faq':
          this.FAQ[index].hide = !this.FAQ[index].hide
          break
        case 'rec':
          this.recommendations[index].hide = !this.recommendations[index].hide
          break
        default:
          console.log('problem')
          break
      }
    },
  },
}
</script>

<style lang="scss">
@import "../utilities/variables";

.accordion-faq {
  background-color: $accordion-background-color;
  color: $text-color;
  cursor: pointer;
  padding: 18px;
  width: 50%;
  text-align: left;
  border: none;
  outline: none;
  transition: 0.4s;
  margin-left: auto;
  margin-right: auto;

  border-radius: 8px;
  overflow: hidden;
  //box-shadow: 0 4px 4px -2px rgba(0,0,0,0.5);
}
</style>
